<template>
    <div>
        <van-button class="btn btn-text" @click="onBtnClick">
            <div class="bh bstart">
                <span class="fz_30">{{text}}</span>
                <div class="bv bc btn-ico" :class="[isHidden?'hidden':'']">
                    <div class="btn-ico-el ico-sort" :class="[isActivate?'':'ico-sort-d']"></div>
                </div>
            </div>
        </van-button>
    </div>
</template>

<script>
export default {
    name: "StateButton",
    props: {
        text: null
    },
    data() {
        return {
            isHidden: true,
            isActivate: false
        };
    },
    methods: {
        onBtnClick() {
            const me = this;
            if (me.isHidden) {
                me.isHidden = false;
            } else {
                me.isActivate = !me.isActivate;
            }
            me.$emit("activateChange", me.isActivate);
        },
        setHidden(v) {
            this.isHidden = v;
        },
        // 重置
        reset() {
            this.isHidden = true;
            this.isActivate = false;
        }
    }
};
</script>

<style scoped lang="scss">
.btn-ico {
    margin-left: 12px;
}
.btn-ico-el {
    width: 16px;
    height: 20px;
}
</style>

